import { concatPassengerNames, getPassengerNames } from '@websky/core/src/utils';
export const getCustomAutocompletePassengerLabel = (traveller) => {
    const { lastName, firstName } = getPassengerNames(traveller);
    return concatPassengerNames(lastName, firstName);
};
export default getCustomAutocompletePassengerLabel;
